import React, { useEffect, useState } from "react";
import styles from "./ImagesDisplay.module.css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import {
  Captions,
  Fullscreen,
  Thumbnails,
  Zoom,
} from "yet-another-react-lightbox/plugins";
import "yet-another-react-lightbox/plugins/captions.css";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Counter from "yet-another-react-lightbox/plugins/counter";
import { jrdSlides, makowSlides, suchaSlides, rabkaSlides } from "./Slides";
import GalleryImages from "../GalleryImages/GalleryImages";
import ConcertSection from "../GalleryFolder/GalleryFolder";
import arrow_back from "../../assets/icons/arrow_back.svg";
import { useTranslation } from "react-i18next";
import arrow_up from "../../assets/icons/arrow_up.svg";

interface ImagesDisplayProps {
  setSelectedConcert: (concert: string | null) => void;
}

const ImagesDisplay: React.FC<ImagesDisplayProps> = ({
  setSelectedConcert,
}) => {
  const { t } = useTranslation();
  const [showScrollToTop, setShowScrollToTop] = useState<boolean>(false);
  const [selectedConcertLocal, setSelectedConcertLocal] = useState<
    string | null
  >(null);
  const [index, setIndex] = useState<number>(-1);

  const concertSections = [
    { slides: rabkaSlides, description: rabkaSlides[0].description },
    {
      slides: makowSlides,
      description: makowSlides[0].description,
    },
    { slides: jrdSlides, description: jrdSlides[0].description },
    { slides: suchaSlides, description: suchaSlides[0].description },
  ];

  const handleConcertClick = (description: string) => {
    setSelectedConcertLocal(description);
    setSelectedConcert(description);
    window.scrollTo(0, 0);
  };

  const handleBackClick = () => {
    setSelectedConcertLocal(null);
    setSelectedConcert(null);
    window.scrollTo(0, 0);
  };

  const handleImageClick = (idx: number) => {
    setIndex(idx);
  };

  const selectedSlides =
    concertSections.find(
      (section) => section.description === selectedConcertLocal
    )?.slides || [];

  const handleScroll = () => {
    if (window.scrollY > 512) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      {!selectedConcertLocal ? (
        <div className={styles.grid}>
          {concertSections.map((section, idx) => (
            <ConcertSection
              key={idx}
              slides={section.slides}
              description={section.description}
              onClick={() => handleConcertClick(section.description)}
            />
          ))}
        </div>
      ) : (
        <>
          <div className={styles.selectedConcertHeading}>
            <p className={styles.title}>{selectedConcertLocal}</p>
            <div className={styles.goBackBtn} onClick={handleBackClick}>
              <p>{t("gallery.goBackBtn")}</p>
              <img src={arrow_back} alt="Go Back Button"></img>
            </div>
          </div>
          <GalleryImages
            slides={selectedSlides}
            onImageClick={handleImageClick}
          />
          {showScrollToTop && (
            <div
              className={styles.scrollToTopBtn}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={arrow_up} alt="Scroll To Top Button" />
            </div>
          )}
        </>
      )}
      <Lightbox
        slides={selectedSlides}
        index={index}
        open={index >= 0}
        close={() => setIndex(-1)}
        plugins={[Fullscreen, Captions, Counter, Zoom, Thumbnails]}
        captions={{
          showToggle: true,
          descriptionTextAlign: "center",
        }}
        counter={{ container: { style: { top: 0 } } }}
        thumbnails={{ position: "bottom", borderColor: "#9d4edd" }}
      />
    </>
  );
};

export default ImagesDisplay;
